export default {
  rules_no_points_month:'該月沒有獲得積分',
  rules_description_title:'積分規則說明：',
  rules_description01:'1、總積分：獲取的各類積分合計，與等級體系關聯。',
  rules_description02:'2、積分類型：根據積分獲取來源，分類為「學習積分」，「貢獻積分」，「主播積分」，「微課積分」，「講師積分」，「互動積分」，可篩選查看明細。',
  rules_description03:'3、積分上限：展示每個積分的日上限。',
  rules_description04:'4、部分活動行為暫時只支持在APP端獲得積分。',

  rules_description_detail:'積分規則明細：',
  rules_sort:'序號',
  rules_behavior:'活動行為',
  rules_score:'單次分值(分)',
  rules_description_type:'說明',
  rules_type_title:'類型',
  rules_maximum_points:'積分上限（每日）：'
}
